{
  "de": {
    "window": {
      "app": "App",
      "customersAnnouncements": "Projekt-Updates",
      "customersDashboard": "Dashboard",
      "customersDecisionDocuments": "Entscheidung",
      "customersDecisionProposals": "Entscheidungsangebote",
      "customersDecisionTickets": "Entscheidung",
      "customersDecisionTicketsShow": "Entscheidung",
      "customersDecisions": "Entscheidungen",
      "customersDocuments": "Dokumente",
      "customersDocumentsAll": "Dokumentenübersicht",
      "customersDocumentsFolder": "Dokumentenkategorie",
      "customersDocumentsFolders": "Dokumentenkategorien",
      "customersInspirationLists": "Inspirationen",
      "customersInspirationListsShow": "Inspirationen",
      "customersInstallmentTerms": "Raten",
      "customersIssues": "Nachbetreuung",
      "customersIssuesList": "Nachbetreuung",
      "customersProjectInformation": "Projektinformationen",
      "customersQuestionLists": "FAQs",
      "customersQuestionListsShow": "FAQs",
      "customersRoot": "Dashboard",
      "customersRootSettingsProfile": "Einstellungen",
      "customersSettingsProfile": "Einstellungen",
      "customersTickets": "Konversationen",
      "customersTicketsNew": "Neue Konversation",
      "customersTicketsShow": "Konversation",
      "employeesClientContacts": "Kontakte",
      "employeesClientContactsNew": "Neuer Kontakt",
      "employeesClientContactsNewCustomer": "Neuer Kunde",
      "employeesClientContactsNewPartner": "Neuer Partner",
      "employeesClientContactsType": "Kontakte",
      "employeesClientDashboard": "Dashboard",
      "employeesClientProjects": "Projekte",
      "employeesClientProjectsNew": "Neues Projekt",
      "employeesClientTickets": "Konversationen",
      "employeesClientTicketsNew": "Neue Konversation",
      "employeesClientTicketsShow": "Konversation",
      "employeesMarketplace": "Marktplatz",
      "employeesProjectActivity": "Aktivität",
      "employeesProjectAnnouncements": "Neuigkeiten",
      "employeesProjectDecisionActivity": "Aktivität",
      "employeesProjectDecisionDocuments": "Entscheidung",
      "employeesProjectDecisionProposalTemplate": "Angebotsvorlagen",
      "employeesProjectDecisionProposals": "Angebote",
      "employeesProjectDecisionReminders": "Erinnerungen",
      "employeesProjectDecisionTickets": "Konversationen",
      "employeesProjectDecisionTicketsShow": "Konversation",
      "employeesProjectDecisionTypeNew": "Neue Entscheidung",
      "employeesProjectDecisionTypes": "Entscheidungen",
      "employeesProjectDecisions": "Entscheidungen",
      "employeesProjectDecisionsEdit": "Entscheidungen",
      "employeesProjectDecisionsNew": "Neue Entscheidung",
      "employeesProjectDocuments": "Dokumente",
      "employeesProjectInformationPageActivity": "Aktivität",
      "employeesProjectInformationPageAftercare": "Nachbetreuung",
      "employeesProjectInformationPageDecisions": "Entscheidungen",
      "employeesProjectInformationPageDocuments": "Dokumente",
      "employeesProjectInformationPageInformation": "Informationen",
      "employeesProjectInformationPageInstallments": "Raten",
      "employeesProjectInformationPageLevels": "Ebenen",
      "employeesProjectInformationPageMilestones": "Meilensteine",
      "employeesProjectInformationPageSpaces": "Nebenflächen",
      "employeesProjectInformationPageSurveys": "Umfragen",
      "employeesProjectInformationPageTaskAssignments": "Aufgaben",
      "employeesProjectInformationPageTasks": "Aufgaben",
      "employeesProjectInformationPageTickets": "Konversationen",
      "employeesProjectInstallmentGroup": "Finanzen",
      "employeesProjectInstallmentGroupNew": "Neuer Zahlungsplan",
      "employeesProjectInstallmentGroups": "Finanzen",
      "employeesProjectInstallmentGroupsList": "Finanzen",
      "employeesProjectInstallmentGroupsMatrix": "Raten",
      "employeesProjectInstallmentNew": "Neue Raten",
      "employeesProjectIssueListTypeIssues": "Punkteliste – Alle Punkte",
      "employeesProjectIssueListTypeNew": "Neue Punkteliste",
      "employeesProjectIssueListTypeUnits": "Punkteliste – Einheitenübersicht",
      "employeesProjectIssueListTypes": "Punktelisten",
      "employeesProjectIssueListUnitDocuments": "Punkte der Einheit – Dokumente",
      "employeesProjectIssueListUnitIssues": "Punkte der Einheit",
      "employeesProjectIssueListUnitTickets": "Punkte der Einheit – Tickets",
      "employeesProjectIssueListUnitTicketsShow": "Konversationen",
      "employeesProjectIssueListsNew": "Neue Punkte",
      "employeesProjectMilestones": "Meilensteine",
      "employeesProjectQuestionLists": "FAQs",
      "employeesProjectQuestionListsShow": "FAQ",
      "employeesProjectSalesUnits": "Verkauf",
      "employeesProjectSurveySummary": "Umfrage",
      "employeesProjectSurveyTypes": "Umfragen",
      "employeesProjectSurveys": "Umfrage",
      "employeesProjectTasks": "Aufgaben",
      "employeesProjectTickets": "Konversationen",
      "employeesProjectTicketsEmailConversations": "E-Mails",
      "employeesProjectTicketsEmailConversationsShow": "E-Mail",
      "employeesProjectTicketsNew": "Neue Konversation",
      "employeesProjectTicketsShow": "Konversationen",
      "employeesProjectTodoLists": "Aufgaben",
      "employeesSettingsClientAftercare": "Nachbetreuung",
      "employeesSettingsClientInformation": "Verwaltung",
      "employeesSettingsClientIntegrations": "Integrationen",
      "employeesSettingsProfile": "Profil",
      "level": "Ebene",
      "mployeesProjectInstallmentGroups": "Finanzen",
      "partnersClientProjects": "Projekte",
      "partnersProjectDecisionDocuments": "Dokumente",
      "partnersProjectDecisionProposals": "Angebote",
      "partnersProjectDecisionTickets": "Konversationen",
      "partnersProjectDecisionTicketsShow": "Konversation",
      "partnersProjectDecisionTypesItems": "Entscheidungen",
      "partnersProjectDecisions": "Entscheidungen",
      "partnersProjectDocuments": "Dokumente",
      "partnersProjectDocumentsUnit": "Dokumente",
      "partnersProjectIssueListTypeIssues": "Punkteliste – Alle Punkte",
      "partnersProjectIssueListTypeUnits": "Punkteliste – Einheitenübersicht",
      "partnersProjectIssueListTypes": "Nachbetreuung",
      "partnersProjectIssueListUnitDocuments": "Punkte der Einheit – Dokumente",
      "partnersProjectIssueListUnitIssues": "Punkte der Einheit",
      "partnersProjectIssueListUnitTickets": "Punkte der Einheit – Tickets",
      "partnersSettingsProfile": "Profil",
      "root": "App",
      "usersPaused": "Ihr Zugriff ist pausiert"
    }
  }
}
